export const BROWSERCOIN_NETWORK = 'browsercoin-pow-v5';
